/* istanbul ignore file */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UntypedFormGroup } from '@angular/forms';
import { HttpBaseService } from '../../../core';
import { environment } from '../../../environments/environment';
import { App, FilterMenuOptions, MapFilter, Project } from '../../models';
import { Field } from '../logic-services/models';

@Injectable({
    providedIn: 'root'
})

export class MapFiltersDataService extends HttpBaseService {
    private route = environment.api + 'apps/';

    constructor(
        private _httpClient: HttpClient
    ) {
        super(_httpClient);
    }

    saveMapFilters(app: App, project: Project, mapFilter: UntypedFormGroup): Observable<MapFilter> {
        const url = `${this.route}${app.id}/projects/${project.id}/map-filters`;
        return this.httpPost(url, mapFilter);
    }

    getMapFilterByProjectId(app: App, project: Project): Observable<MapFilter> {
        const url = `${this.route}${app.id}/projects/${project.id}/map-filters`;
        return this.httpGet(url);
    }

    getMapFilterValuesByProjectId(app: App, project: Project, allFields: Field[]): Observable<FilterMenuOptions> {
        const url = `${this.route}${app.id}/projects/${project.id}/map-filters/filter-menu`;
        const dataToSend = {
            fields: allFields
        };
        return this.httpPost(url, dataToSend);
    }

    getMapFilterValuesBySummaryProjectId(app: App, project: Project, allFields: Field[]): Observable<FilterMenuOptions> {
        const url = `${this.route}${app.id}/summary-projects/${project.id}/map-filters/filter-menu`;
        const dataToSend = {
            fields: allFields
        };
        return this.httpPost(url, dataToSend);
    }

    getSitesByFilterValues(app: App, project: Project, mapFilterMenuOptions: FilterMenuOptions): Observable<string[]> {
        const url = `${this.route}${app.id}/projects/${project.id}/map-filters/sites`;
        return this.httpPost(url, mapFilterMenuOptions);
    }

    getSitesByFilterValuesBySummaryProjectId(app: App, project: Project, mapFilterMenuOptions: FilterMenuOptions): Observable<string[]> {
        const url = `${this.route}${app.id}/summary-projects/${project.id}/map-filters/sites`;
        return this.httpPost(url, mapFilterMenuOptions);
    }

    getMapFilterMenuByProjectId(app: App, project: Project): Observable<FilterMenuOptions> {
        const url = `${this.route}${app.id}/projects/${project.id}/map-filters/filter-menu`;
        return this.httpGet(url);
    }

    getMapFilterMenuBySummaryProjectId(app: App, project: Project): Observable<FilterMenuOptions> {
        const url = `${this.route}${app.id}/summary-projects/${project.id}/map-filters/filter-menu`;
        return this.httpGet(url);
    }
}
